import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { cartMobx } from 'restaurant'
import { timePickMobx } from '@mobxStore'
import TimePickController from '@ctrls/timePickController'
import { Icon } from '@cps'
import './index.scss'

interface IProps {
  no: string;
  startTime?: string;
  pickTimeRange?: string;
  onChange?: (data: any) => void;
}

const Reserve: FC<IProps> = ({ no, startTime, pickTimeRange, onChange }) => {
  const handlePickTime = () => {
    TimePickController.handleAppointment('product', {
      no,
      startTime,
      pickTimeRange,
      callback: () => {
        onChange(timePickMobx.productReserveInfo)
      }
    })
  }

  if (!timePickMobx.productRuleMap?.[no] || !timePickMobx.productTimePickList?.length) {
    return null
  }

  return (
    <div className='product-reserve' data-cypid='productReserveClick' onClick={handlePickTime}>
      <div className='product-reserve-title'>{i18n.t(`newCart.${cartMobx.info.eatType}time`)}</div>
      <div className='product-reserve-content'>
        <span>{startTime ? timePickMobx.getTimeText('product', { startTime, pickTimeRange }) : ''}</span>
        <i className='iconfont icon-chevron-right'></i>
      </div>
    </div>
  )
}

export default observer(Reserve)
